module.exports = __webpack_public_path__ + "static/media/fa-regular-400.766913e6.ttf";